var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("h2", { staticClass: "px-3 pt-3" }, [
          _vm._v(_vm._s(_vm.$t("newTrip.whichServiceYouWant")))
        ]),
        _c(
          "v-row",
          { staticClass: "text-center" },
          [
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5 fill-height",
                attrs: { cols: "12", md: "4" }
              },
              [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("newTrip.travelServicesOnly")))
                ]),
                _c("v-icon", { attrs: { size: "150px" } }, [
                  _vm._v("local_grocery_store")
                ]),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("newTrip.travelServicesOnlyDescription")) +
                      " "
                  )
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { bottom: "" },
                    on: {
                      click: function($event) {
                        return _vm.redirectToBooking()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5 fill-height",
                attrs: { cols: "12", md: "4" }
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("newTrip.delegationProcess")))]),
                _c("v-icon", { attrs: { size: "150px" } }, [
                  _vm._v("event_note")
                ]),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("newTrip.delegationProcessDescription")) +
                      " "
                  )
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { bottom: "" },
                    on: {
                      click: function($event) {
                        return _vm.redirectToDelegation()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }